import { AvailablePaymentMethods } from "@stripe/stripe-js";
import { useExpressCheckoutContext } from "./ExpressCheckout.context";
import { ButtonMap } from "./ExpressCheckout.buttons";
import { IconButton, DropdownMenu, Box } from "flicket-ui";
import { DotsThree } from "@phosphor-icons/react";
import { useState } from "react";

export const ExpressCheckoutButtonRow = ({
  onClick,
  breakpoint,
}: {
  onClick: (paymentType: keyof AvailablePaymentMethods) => void;
  breakpoint: "xxs" | "xs";
}) => {
  const {
    availablePaymentMethods,
    hasPaymentMethods,
  } = useExpressCheckoutContext();

  if (!hasPaymentMethods) return null;

  const firstTwoPayments = availablePaymentMethods?.slice(0, 2) || [];
  const remainingPayments = availablePaymentMethods?.slice(2) || [];
  const paymentCountOverflow = remainingPayments?.length > 0;

  return (
    <>
      {firstTwoPayments.map((method) => {
        const ButtonComponent = ButtonMap[method];
        return (
          <ButtonComponent
            key={method}
            onClick={() => onClick(method)}
            flex={1}
            maxW={{ [breakpoint]: "160px" }}
          />
        );
      })}

      {paymentCountOverflow && (
        <AdditionalButtonDropdown
          paymentMethods={remainingPayments}
          onClick={onClick}
        />
      )}
    </>
  );
};

function AdditionalButtonDropdown({
  paymentMethods,
  onClick,
}: {
  paymentMethods: (keyof AvailablePaymentMethods)[];
  onClick: (paymentType: keyof AvailablePaymentMethods) => void;
}) {
  const [open, setOpen] = useState(false);
  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenu.Trigger>
        <IconButton variant="solid" fontWeight="bold" isActive={open}>
          <DotsThree weight="bold" />
        </IconButton>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="end">
        {paymentMethods.map((method) => {
          const ButtonComponent = ButtonMap[method];
          return (
            <DropdownMenu.CustomItem key={method} title="">
              <ButtonComponent
                onClick={() => onClick(method)}
                flex={1}
                maxW={{ xs: "160px" }}
                mx={1}
                my={"1/2"}
              />
            </DropdownMenu.CustomItem>
          );
        })}
      </DropdownMenu.Content>
    </DropdownMenu>
  );
}
